import { Injectable, signal } from '@angular/core';
import { MondelezDataService } from './mondelez-data.service';
import { MondelezService } from './mondelez.service';
import { BehaviorSubject, ReplaySubject, Subject, switchMap } from 'rxjs';
import { GlobalFilter, InsightFilter } from '../interfaces/global-filter-model';

@Injectable()
export class GlobalFilterService {
  private _currentFilter = undefined;

  private _globalFilters = new BehaviorSubject<GlobalFilter>(null);
  public globalFilters = this._globalFilters.asObservable();

  private _currentPopupFilter = undefined;
  private _globalPopupFilters = new BehaviorSubject<GlobalFilter>(null);
  public globalPopupFilters = this._globalPopupFilters.asObservable();

  private _currentInsightFilters = undefined;
  private _insightFilter = new BehaviorSubject<InsightFilter>(null);
  public insightFilter = this._insightFilter.asObservable();

  private _mapViewFilters = new ReplaySubject<any>(1);
  public mapViewFilters = this._mapViewFilters.asObservable();

  private _filterMasterData = new BehaviorSubject<any>(null);
  public filterMasterData = this._filterMasterData.asObservable();

  public filterCleared = new Subject<boolean>();

  public networkAccessWarningVisible = signal<boolean>(false);

  constructor(private mdlzService: MondelezService, private mdlzDataService: MondelezDataService) {
    this.mdlzDataService.currentScenarioChanged
      .pipe(switchMap((scenario) => this.mdlzService.fetchFilterData({ iteration_code: scenario.iteration_code, scenario_id: scenario.scenario_id })))
      .subscribe((filterMaster) => {
        this._currentFilter = undefined;
        if (filterMaster) {
          const clonedData = structuredClone({ ...filterMaster, iteration_start_year: filterMaster['start_year'] });
          this._filterMasterData.next(clonedData);
          this.networkAccessWarningVisible?.set(false);
        } else {
          this.networkAccessWarningVisible?.set(true);
          this._currentFilter = undefined;
          const currentYear = new Date().getFullYear();
          this._filterMasterData?.next({
            filter: [],
            iteration_start_year: currentYear,
            start_year: currentYear,
            end_year: currentYear,
            hist_end_year: currentYear,
            hist_start_year: currentYear,
          });
        }
      });
  }

  public updateGlobalFiltersSelection(selection: GlobalFilter) {
    this.updateGlobalPopupFiltersSelection(null);
    this._currentFilter = selection;
    this._globalFilters.next(selection);
  }

  public updateGlobalPopupFiltersSelection(selection: GlobalFilter) {
    this._currentPopupFilter = selection;
    this._globalPopupFilters.next(selection);
  }

  public updateInsightFiltersSelection(selection: InsightFilter) {
    this._currentInsightFilters = selection;
    this._insightFilter.next(selection);
  }

  public updateMapViewFiltersSelection(selection: any) {
    this._mapViewFilters.next(selection);
  }

  // public updateFilterMasterData(data) {
  //   this._currentFilter = undefined;
  //   const clonedData = structuredClone({ ...data, iteration_start_year: data.start_year });
  //   this._filterMasterData.next(clonedData);
  // }

  public getFilterMasterData() {
    return this._filterMasterData.getValue();
  }

  public get currentFilters() {
    return this._currentFilter;
  }

  public get currentPopupFilters() {
    return this._currentPopupFilter;
  }

  public get currentInsightFilters() {
    return this._currentInsightFilters;
  }

  resetFilters() {
    this._globalFilters.next(null);
    this._filterMasterData.next(null);
    this._globalPopupFilters.next(null);
    this._insightFilter.next(null);
    this._mapViewFilters.next(null); // Reset to an empty object
  }
}
